import { render, staticRenderFns } from "./InformationEdit.vue?vue&type=template&id=ac6b38c4&"
import script from "./InformationEdit.vue?vue&type=script&lang=ts&"
export * from "./InformationEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports